<template>
  <div>
    <el-table v-loading="isLoading" element-loading-background="rgba(0, 0, 0, 0.8)" class="table_box pc_table_box"
              :data="tableData" style="width: 100%" :row-style="{ height: '59px' }">
      <el-table-column prop="deal" :label="$t('contract2')" width="120px"></el-table-column>
      <el-table-column prop="amount" :label="$t('quantity')" width="80px"></el-table-column>

      <el-table-column prop="type" :label="$t('direction')" width="80px">
        <template slot-scope="scope">
          <span v-if="scope.row.type===1" style="color: rgba(46, 189, 133, 1);">{{ $t("long_position") }}</span>
          <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t("short_position") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('open_price')" width="110px"></el-table-column>
      <el-table-column prop="price2" :label="$t('current_price2')" width="110px"></el-table-column>
      <el-table-column prop="force" :label="$t('estimated_liquidation_price')" width="110px"></el-table-column>
      <el-table-column prop="marginRate" :label="$t('margin_ratio')"></el-table-column>
      <el-table-column prop="margin" :label="$t('margin')" width="100px"></el-table-column>
      <el-table-column prop="pan" :label="$t('profit_loss')" width="150px">
        <template slot-scope="scope">
          <span
              :style="scope.row.pan>0?'color:rgba(46, 189, 133, 1)':'color:rgba(239, 69, 74, 1);'">{{ scope.row.pan }}({{ scope.row.panRate??0 }}%)</span>
        </template>
      </el-table-column>

      <el-table-column prop="operate" width="100px" align="center">
        <template slot="header" slot-scope="scope">
          <div class="zdy">{{ $t("action") }}</div>
        </template>
        <template slot-scope="scope">
          <div class="operate_box" v-if="!scope.row.isLimit && showOrder">
            <div class="operate_1" @click="showDialog(scope.row,1)" style="color:rgba(24, 26, 32, 1) !important;">{{ $t("market_order") }}
            </div>
            <div class="operate_1" @click="showDialog(scope.row,2)"  style="color:rgba(24, 26, 32, 1) !important;" >{{ $t("limit_order") }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="target" :label="$t('take_profit_stop_loss')" width="120px">
        <template slot-scope="scope">
          <div v-if="scope.row.target.length==0">-/-(0)</div>
          <div v-else style="display: flex;align-items: center">
            <div>
            <span v-if="scope.row.target.hight=='0'">-</span>
            <span v-if="scope.row.target.hight!='0'">{{scope.row.target.high}}</span>
            <br/>
            <span v-if="scope.row.target.low=='0'">-</span>
            <span v-if="scope.row.target.low!='0'">{{scope.row.target.low}}</span>
            </div>
            <div style="margin-left: 10px">({{scope.row.target.length}})</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pan" :label="$t('share2')" align="right" width="60px">
        <template slot-scope="scope">
          <span @click="share(scope.row)" class="share_img"><img src="../assets/imgs/share2.svg"/></span>
        </template>
      </el-table-column>

    </el-table>
    <el-table v-loading="isLoading" ref="mobileTable" element-loading-background="rgba(0, 0, 0, 0.8)" class="table_box mobile_table_box"
              :data="tableData" :style="{padding:0,marginBottom:'200px',marginLeft:'15px',marginRight:'15px',width:'auto'}" @row-click="toggleExpand">>
      <el-table-column type="expand" :label="'#'" width="20px">
        <template slot-scope="props">
          <div class="data_content" style="margin-top: 0">
            <div class="flex_c  flex_d">
              <div class="data_lits_box type_1">
                <div>
                  <div class="list">
                    <div class="left">
                      <span style="border: none" class="title">{{$t('quantity')}}</span>
                    </div>

                    <div class="right">
                      <span style="border: none" class="title">{{$t('margin_ratio')}}</span>
                    </div>
                  </div>
                  <div class="list">
                    <div class="left value">{{ props.row.amount }}</div>
                    <div class="right value">{{ props.row.marginRate }}</div>
                  </div>
                </div>
                <div style="margin-top: 14px">
                  <div class="list">
                    <div class="left">
                      <span style="border: none" class="title">{{$t("margin")}}</span>
                    </div>
                    <div class="right">
                      <span style="border: none" class="title">{{$t('profit_loss')}}</span>
                    </div>
                  </div>
                  <div class="list">
                    <div class="left value">{{ props.row.margin }}</div>
                    <div :class="'right value '+(props.row.panRate>0)?'long':'short'">{{ props.row.pan }}({{ props.row.panRate }}%)</div>
                  </div>
                </div>
                <div style="margin-top: 14px">
                  <div class="list">
                    <div class="left">
                      <span style="border: none" class="title">{{$t('take_profit_stop_loss')}}</span>
                    </div>
                    <div class="right">
                      <span style="border: none" class="title">{{$t('estimated_liquidation_price')}}</span>
                    </div>
                  </div>
                  <div class="list">
                    <div class="left value">
                      <div v-if="props.row.target.length==0">-/-(0)</div>
                      <div v-else style="display: flex;align-items: center">
                        <div>
                          <span v-if="props.row.target.hight=='0'">-</span>
                          <span v-if="props.row.target.hight!='0'" class="long">{{props.row.target.high}}</span>
                          <br/>
                          <span v-if="props.row.target.low=='0'">-</span>
                          <span v-if="props.row.target.low!='0'" class="short">{{props.row.target.low}}</span>
                        </div>
                        <div style="margin-left: 10px">({{props.row.target.length}})</div>
                      </div>
                    </div>
                    <div :class="'right value'">{{ props.row.force }}</div>
                  </div>
                </div>

                <div class="operate_box" style="margin-top: 16px" v-if="!props.row.isLimit">
                  <div class="limit" @click="showDialog(props.row,2,true)">{{$t('limit_close')}}</div>
                  <div class="market" @click="showDialog(props.row,1,true)">{{$t('market_close')}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deal" :label="$t('contract2')" width="80px"></el-table-column>
      <el-table-column prop="type" :label="$t('direction')" align="left"  width="50px">
        <template slot-scope="scope">
          <span v-if="scope.row.type===1" style="color: rgba(46, 189, 133, 1);">{{ $t("long") }}</span>
          <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t("short") }}</span>
        </template>

      </el-table-column>
      <el-table-column prop="price" :label="$t('open_price')" align="left" >
      </el-table-column>
      <el-table-column prop="price2" :label="$t('current_price2')" >
      </el-table-column>
      <el-table-column prop="share" align="right" :label="$t('share2')" width="60px">
        <template slot-scope="scope">
          <span @click="share(scope.row)"><img src="../assets/imgs/share2.svg" width="14" height="14"/></span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :modal="false" :title="selectRow.coin+'/'+selectRow.name" :visible.sync="dialogVisible"
    >
      <div class="dialog_title"><span class="more" v-if="selectRow.type==1">{{ $t('closeLong') }}</span> <span
          v-if="selectRow.type==0" class="less">{{ $t("closeShort") }}</span></div>
      <div>
        <div class="dialog_list">
          <div class="left">{{ $t("price") }}</div>
          <div class="right">
            <span v-if="type==1">{{$t('market_order')}}</span>
            <input v-if="type!=1" v-model="selectRow.operate" class="amount_input"/>
          </div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t("quantity") }}</div>
          <div class="right"><input v-model="amountInput" class="amount_input" autofocus="autofocus"/></div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t("estimated_pnl") }}</div>
          <div class="right" :style="amountPnl>0?'color:rgba(46, 189, 133, 1)':'color:rgba(239, 69, 74, 1);'">
            {{ amountPnl?.toFixed(2) }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
        :visible.sync="dialogMVisible"
        direction="btt"
        size="290"
        :append-to-body="true"
        :with-header="false"
    >
      <div class="drawer">
        <div class="minus" @click="dialogMVisible=false"></div>
        <div class="title">
          <div class="title_c" >{{mTitle}}</div>
          <img class="title_i"  src="../assets/imgs/delete.svg" @click="dialogMVisible=false"/>
        </div>
        <div class="item">
          <input :placeholder="$t('price')" v-model="limitPrice" class="price" :disabled="this.type==2"/>
        </div>
        <div class="item">
          <input :placeholder="$t('quantity')" v-model="amountInput" class="price"/>
        </div>
        <div class="confirm" @click="confirmM">{{$t('confirm')}}</div>
      </div>
    </el-drawer>
    <share1 ref="share1" :token="this.token" :contract="this.contractAddress"/>
  </div>
</template>

<script>
import {
  createAndCall,
  createLeadingContractAndCall,
  createLeadingContractAndSend, createOrderBookAndCall, createPerpOptionAndCall, createTradeAndCall,
  createUnderlingAndCall, getContractOrder, getContractOrder2, getContractWithCache,
  getErc20Info, getGasReward, getSelectTokenInfo,
  getValue
} from "../utils/contract";
import {BigNumber, ethers} from "ethers";
import {CACHE_KEY, Contract, Method, Underling} from "../config/const";
import {
  transTime2Date,
  transBig2number,
  transNumber2Big,
  isMobile,
  getForcePriceV2,
  getSecurityRate2
} from "../utils/functions";
import {getLastPrice, registerService, removeService} from "../service/priceService";
import config from "../config/config";
import {getAccount} from "../utils/wallet";
import Share1 from "./share1.vue";
import {MESSAGE, registerMessage, removeMessage} from "../utils/message";

export default {
  name: "activate0",
  components: {Share1},
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      dialogVisible: false,
      dialogMVisible: false,
      isLoading: false,
      selectRow: {
        amount: 0
      },
      selectPnl: "0",
      currentPrice: {},
      showOrder: false,
      isMobile: false,
      positions: {},
      amountInput: "",
      amountPnl: 0,
      type: 0,
      limitPrice:0,
      levelBTC:100,
      levelETH:100,
      mTitle:""
    }
  },
  methods: {
    getAmountPnl(amountInput) {
      if (this.type == 1) {
        let profit = Number(amountInput) * (Number(this.selectRow.price2) - Number(this.selectRow.price));
        return this.selectRow.isBuy ? profit : -profit;
      } else if (this.type == 2) {
        let profit = Number(amountInput) * (Number(this.selectRow.operate) - Number(this.selectRow.price));
        return this.selectRow.isBuy ? profit : -profit;
      }
    },
    async confirmM(){
      this.dialogMVisible = false
      if (this.type == 2) {
        await this.trade(this.selectRow,true)
      } else if (this.type == 1) {
        await this.trade(this.selectRow,false)
      }
    },
    async showDialog(row, type, isMobile = false) {
      this.selectRow = row;
      this.type = type;
      if (!isMobile) {
        this.dialogVisible = true;
      } else {
        this.mTitle=this.type==1?this.$t('market_price'):this.$t('limit_price')
        this.dialogMVisible = true;
      }


      let priceAll = await getLastPrice();
      let price = transBig2number(priceAll[row.name].price, priceAll[row.name].decimal);
      if (type == 2) {
        this.limitPrice=price;
      } else {
        this.limitPrice=this.$t('market_price')
      }

      this.amountInput = this.selectRow.amount;

      this.$forceUpdate()

    },
    toggleExpand(row) {
      this.$refs.mobileTable.toggleRowExpansion(row);
    },

    async getActiveOrder() {
      if (!this.contractAddress) {
        return;
      }
      let time=new Date().getTime();
      let selectToken = await getSelectTokenInfo(this.token);


      let orders = await getContractOrder(this.token,this.contractAddress, selectToken.orderBook);
      let price = await getLastPrice();
      let priceMap = {
        [Underling.BTC]: 0,
        [Underling.ETH]: 0
      }
      if (price) {
        priceMap = {
          [Underling.BTC]: transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal),
          [Underling.ETH]: transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal)
        }
      }

      let tableData = [];

      this.positions = orders;

      //获取limit 订单
      let orderIds = await createOrderBookAndCall(selectToken.orderBook, Method.getUserLimitOrdersID, this.token, this.contractAddress)
      let limitOrders = await createTradeAndCall(selectToken.tradeAgent, Method.getLimitOrders, orderIds)
      let targetOrders = await createTradeAndCall(selectToken.tradeAgent, Method.getTriggerConditions, orderIds)

      for (let i in orders) {
        if (orders[i].size.lte(BigNumber.from("0"))) {
          continue;
        }
        tableData.push({
          order: i,
          deal: selectToken.symbol + "-" + orders[i].name,
          coin: selectToken.symbol,
          type: orders[i].isBuy ? 1 : 0,
          orderType:orders[i].isBuy ? 1 : 2,
          isBuy: orders[i].isBuy,
          time: "",
          price: orders[i].price,
          price2: 0,
          pan: 0,
          amount: transBig2number(orders[i].size, 18, 18,true),
          name: orders[i].name,
          margin: transBig2number(orders[i].margin),
          nextTime: "",
          timePrice: "",
          operate: priceMap[orders[i].name],
          pnl: 0,
          isLimit: "",
          value: parseFloat(transBig2number(orders[i].value)),
          target:this.getTarget(orders[i],limitOrders,targetOrders),
        })
      }
      tableData.reverse();
      this.tableData=tableData;
      console.log("active table data is",this.tableData);

      let selectInfo = await getSelectTokenInfo(this.token)
      let levelBTC = await createPerpOptionAndCall(selectInfo.perpetual, Method.getUserLeverage,this.token ,this.contractAddress, "BTC");
      let levelETH = await createPerpOptionAndCall(selectInfo.perpetual, Method.getUserLeverage,this.token, this.contractAddress, "ETH");

      this.levelBTC=parseInt(levelBTC)
      this.levelETH=parseInt(levelETH)

    },
    getTarget(order,limitOrders,targetOrders){
      let targetWinPrice=[];
      let targetLossPrice=[];
      let limitOrderLength=0;
      for(let i in limitOrders){
        let limitOrder=limitOrders[i];
        if(limitOrder.orderType!=11 || limitOrder.token!=this.token || limitOrder.direct!=order.direct || limitOrder.name!=order.name){
          continue;
        }
        limitOrderLength++;
        if(targetOrders[i].gainTriggerPrice.toString()!="0"){
          targetWinPrice.push(targetOrders[i].gainTriggerPrice)
        }
        if(targetOrders[i].lossTriggerPrice.toString()!="0"){
          targetLossPrice.push(targetOrders[i].lossTriggerPrice)
        }
      }
      if(limitOrderLength==0){
        return {
          high:0,
          low:0,
          length:0
        }
      }
      targetWinPrice.sort((t1,t2)=>{
        return t1.gt(t2)?1:-1
      })
      targetLossPrice.sort((t1,t2)=>{
        return t1.lt(t2)?1:-1
      })

      return {
        high:targetWinPrice.length==0?"0":transBig2number(targetWinPrice[0]),
        low:targetLossPrice.length==0?"0":transBig2number(targetLossPrice[0]),
        length:limitOrderLength
      }


    },


    async updatePrice(prices) {
      try {
        this.currentPrice = {
          BTC: transBig2number(prices[Underling.BTC].price, prices[Underling.BTC].decimal),
          ETH: transBig2number(prices[Underling.ETH].price, prices[Underling.ETH].decimal),
          SOL: transBig2number(prices[Underling.SOL].price, prices[Underling.ETH].decimal)
        }
        let panTotal = 0;
        let total = 0;
        let margin = 0;

        let priceBig = {
          BTC: BigNumber.from(transNumber2Big(transBig2number(prices["BTC"].price, prices["BTC"].decimal))),
          ETH: BigNumber.from(transNumber2Big(transBig2number(prices["ETH"].price, prices["ETH"].decimal))),
          SOL: BigNumber.from(transNumber2Big(transBig2number(prices["SOL"].price, prices["SOL"].decimal)))
        }
        let marginRate="";

        for (let i in this.tableData) {
          let item = this.tableData[i];
          if(!item){
            continue;
          }
          let name = this.tableData[i].name ?? "BTC";
          let currPrice = transBig2number(prices[name].price, prices[name].decimal);
          this.tableData[i].price2 = currPrice;
          let pan = 0;
          let sub = 0;
          if (item.isBuy) {
            sub = parseFloat(currPrice) - parseFloat(this.tableData[i].price);
          } else {
            sub = -(parseFloat(currPrice) - parseFloat(this.tableData[i].price));
          }

          let forcePrice = await getForcePriceV2(this.token, this.contractAddress, this.positions, name, priceBig);
          this.tableData[i].force = forcePrice;

          marginRate = await getSecurityRate2(this.token, this.contractAddress, this.positions, priceBig);
          this.tableData[i].marginRate = marginRate+"%";


          pan = (sub * parseFloat(this.tableData[i].amount)).toFixed(2);

          this.tableData[i].pan = pan;

          panTotal += parseFloat(this.tableData[i].pan);
          total += parseFloat(this.tableData[i].value);
          margin += parseFloat(this.tableData[i].margin);

          let panRate2=parseFloat(pan)*100/parseFloat(this.tableData[i].margin);
          panRate2=isNaN(panRate2)?0:panRate2.toFixed(2);
          this.tableData[i].panRate=panRate2;

        }
        this.$emit("pan-total", {pan: panTotal, margin: margin,marginRate:marginRate}, total);
      } catch (e) {
        console.log("error is", e);
      }

    },
    async trade(row,isLimit) {
      this.$store.commit('setLoading', true)
      setTimeout(()=>{
        this.$store.commit('setLoading', false)
      },30000);

      let tigger=await getGasReward(this.token,row.name)

      let price="0";
      let prices = await getLastPrice();
      let priceData = transBig2number(prices[row.name].price, prices[row.name].decimal);
      if(isLimit){
        if(this.isMobile){
          price=transNumber2Big(this.limitPrice)
        }else{
          price=transNumber2Big(row.operate)
        }
      }else{
        if(row.isBuy) {
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(90)).div(BigNumber.from(100));
        } else if (!row.isBuy) {
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(110)).div(BigNumber.from(100));
        }
      }

      const tx = await createLeadingContractAndSend(
          this.contractAddress, Method.trade,
          [
            row.name,
            transNumber2Big(this.amountInput),
            price,
            1,
            2,
            row.isBuy ? 1 : 2,
            isLimit?0:21,
            parseInt(new Date().getTime() / 1000) + 31536000,
            ethers.utils.arrayify("0x"),
          ], tigger);

      if (tx) {
        this.init()
      }
    },
    async open() {
      this.dialogVisible = true
    },

    async ok1() {
      this.trade(this.selectRow,this.type==2)
      this.dialogVisible = false
    },
    async init() {
      this.isLoading = true;
      let time=new Date().getTime();
      await this.getActiveOrder()

      let info = await getContractWithCache([Contract.LeadingContractFactory, Method.getLeadingContractInfoByAddress, [this.contractAddress]],3600000,createAndCall)
      let account = await getAccount();
      if (info.traderAddress.toLowerCase() === account.toLowerCase()) {
        this.showOrder = true;
      }

      let price=await getLastPrice();
      await this.updatePrice(price)


      this.isLoading = false;

    },
    async share(row){
      if(this.$refs.share1){
        this.$refs.share1.show(row,this.levelBTC,this.levelETH,false);
      }
    },
    async reciveMsg(msg,data){
      if(msg==MESSAGE.POSITION_UPDATE){
        this.init()
      }
    }
  },
  mounted() {
    registerService(this.updatePrice);
    this.isMobile = isMobile();
    registerMessage(this.reciveMsg)
  },
  unmounted() {
    removeService(this.updatePrice);
    removeMessage(this.reciveMsg)
  },
  created() {
    this.isMobile = isMobile();
  },
  watch: {
    amountInput(val) {
      let profit = this.getAmountPnl(val);
      this.amountPnl = profit;
    }
  }
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
::v-deep .el-table td.el-table__cell .operate_1, .el-table td.el-table__cell .operate_2, .zdy {
  //color: #A5D63F !important;
}


.bottom-dialog {
  /* 定位到页面底部 */
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  margin: 0; /* 移除默认的 margin */

  /* 可选：设置宽度，或者让内容自适应 */
  width: 100%; /* 或者你想要的固定宽度 */
  max-width: 600px; /* 例如，最大宽度 */
}

.zdy {
  cursor: pointer;
}

.limit-dialog {
  width: 380px;
}

::v-deep .el-dialog {
  width: 380px !important;
}

::v-deep .operate_3 .el-input__inner {
  background-color: transparent !important;
  border: 0;
  height: 15px;
  line-height: 22px;
  color: #ffffff;
  width: 60px !important;
  padding: 0px !important;
  text-align: center;
}

::v-deep .el-dialog__title {
  font-size: 20px;
  font-weight: 400 !important;
  color: #ffffff;
}

::v-deep .el-dialog__footer {
  padding: 0px 24px 22px !important;
}

::v-deep .el-table, .el-table__expanded-cell {
  background-color: transparent;
}

.amount_input {
  text-align: right;
  background: transparent;
  border: none;
  color: #E5E5E5;
}

.amount_input:focus {
  outline: none;
}

@media (max-width: 750px) {
  ::v-deep .el-dialog {
    width: 80% !important;
  }
  ::v-deep .share-c{
    width: 100% !important;
  }
  .data_content {
    background: rgba(18, 18, 18, 1);
    border-radius: 10px;
    padding: revert;

    .flex_c{
      margin-bottom: revert !important;
    }
    .type_1{
      margin-bottom: revert !important;
    }
    .data_lits_box {
      border-color: transparent !important;
    }

    .title {
      font-size: 13px !important;
      font-weight: 400 !important;
      letter-spacing: -0.4px;
      line-height: 18.82px;
      color: rgba(128, 128, 128, 1) !important;
    }

    .value {
      font-size: 13px !important;
      font-weight: 500 !important;
      letter-spacing: -0.4px;
      line-height: 15.24px;
      color: rgba(255, 255, 255, 1) !important;
    }

    .operate_box {
      display: flex;
      gap: 9px;
      height: 32px;
      justify-content: center;

      .limit {
        flex: 1;
        height: 32px;
        background: rgba(198, 254, 97, 1);
        border-radius: 6px;
        text-align: center;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 1);
        text-align: center;
        line-height: 32px;
      }

      .market {
        flex: 1;
        height: 32px;
        background: rgba(56, 56, 56, 1);
        border-radius: 6px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0px;
        color: rgba(198, 254, 97, 1);
        text-align: center;
        line-height: 32px;
      }
    }
  }
  .drawer {

    background: rgba(19, 20, 21, 1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding-bottom: 60px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 8px;

    .minus{
      margin: auto;
      margin-bottom: 10px;
      width: 40px;
      height: 4px;
      border-radius: 2px;
      background: rgba(128, 128, 128, 1);
    }

    .title{
      display: flex;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 10px;

      .title_c{
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 18.75px;
        color: rgba(255, 255, 255, 1);
      }
      .title_i{
        width: 16px;
        height: 16px;
      }

    }

    .item{
      margin-top: 14px;
      box-sizing: border-box
    }
    .el-drawer{
      background: transparent !important;
    }

    .price {
      border: 1px solid rgba(56, 56, 56, 1);
      background: transparent;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.8px;
      line-height: 16.41px;
      color: rgba(128, 128, 128, 1);
      display: block;
      height: 40px;
      border-radius: 6px;
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      box-sizing: border-box
    }

    .price:focus {
      outline: none;
    }

    .confirm {
      margin-top: 32px;
      background: rgba(198, 254, 97, 1);
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 32px;
      color: rgba(24, 26, 32, 1);
      text-align: center;
    }
  }

  ::v-deep .el-table__header{
    width: revert !important;
  }
  ::v-deep .el-table__body{
    width: revert !important;
  }
  ::v-deep .el-table th.el-table__cell > .cell{
    font-weight: 400;
  }

}


::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 4px;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #333;
  border-radius: 2px;
}
::v-deep .el-drawer{
  background: transparent !important;
}

.list{
  display: flex;
  justify-content: space-between;
}

.share_img{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

::v-deep .el-table .cell{
  line-height: revert;
  padding-left: 0px;
}

::v-deep .el-table th.el-table__cell>.cell{
  padding-left: 0px;
}
.long{
  color:#3EB060
}
.short{
  color:#C74242
}

</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
<style>
.el-table, .el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}
</style>
